import { Button, Modal } from "react-bootstrap";
import { createGlobalStyle } from "styled-components";

/*
  Foto ampliada.

  Componente à parte porque é aberto de dois lugares: da miniatura na listagem e
  do preview dentro dos modais de cadastro/edição. Assim os dois abrem a mesma
  janela, com o mesmo enquadramento.
*/

/*
  O Bootstrap dá o mesmo z-index (1050) a todos os modais e 1040 a todos os
  fundos. Aberta de dentro do modal de editar, a foto até aparecia na frente
  (vem depois no DOM), mas o fundo escuro dela ficava ATRÁS daquele modal: ele
  não escurecia e os dois viravam um painel só, colados. Subindo os dois níveis,
  o de editar escurece e fica claro que a foto é uma janela separada.
*/
const NivelAcimaDosModais = createGlobalStyle`
  .backdrop-foto-ampliada { z-index: 1065; }
  .modal-foto-ampliada { z-index: 1070; }
`;

/**
 * JSDoc explícito: é .jsx consumido por .tsx.
 *
 * @param {{
 *   url?: string | null,
 *   nome?: string,
 *   onFechar: () => void,
 * }} props
 */
function VisualizadorFoto({ url = null, nome = "Foto do usuário", onFechar }) {
  return (
    <>
      <NivelAcimaDosModais />

      <Modal
        show={!!url}
        onHide={onFechar}
        centered
        size="lg"
        className="modal-foto-ampliada"
        backdropClassName="backdrop-foto-ampliada"
      >
        <Modal.Header closeButton>
          <Modal.Title className="d-flex align-items-center" style={{ fontSize: "1.1rem" }}>
            <i className="fas fa-camera text-primary mr-2" />
            {nome || "Foto do usuário"}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body className="text-center bg-light p-3">
          {url && (
            <img
              src={url}
              alt={nome || "Foto do usuário"}
              /*
                contain e limite de altura: a foto vem do tamanho que enviaram, e
                sem isto um retrato em pé estouraria a altura da tela.
              */
              style={{
                maxWidth: "100%",
                maxHeight: "70vh",
                objectFit: "contain",
                borderRadius: "8px",
              }}
            />
          )}
        </Modal.Body>

        <Modal.Footer>
          <a
            href={url || undefined}
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-outline-primary mr-2"
          >
            <i className="fas fa-external-link-alt mr-1" />
            Abrir em nova aba
          </a>
          <Button variant="secondary" onClick={onFechar}>
            Fechar
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default VisualizadorFoto;
